<!--
Non-bootstrap version of Alert.vue - intended to be a drop-in replacement.
bootstrap modals are breaking with $.... modal is not a function :-(

@author cm359n
-->
<template>
  <div>
    <NewModalPopup v-if="showAlert" id="alert" title="Alert" displayAt="top">
      <p>{{ msg }}</p>
      <div class="w-100">
        <button type="button" class="btn btn-primary w-100"
        @click="doCallback()">OK</button>
      </div>
    </NewModalPopup>
  </div>
</template>

<script>
import NewModalPopup from '@/components/NewModalPopup.vue'

export default {
  name: 'NewAlert',
  components: {
    NewModalPopup
  },
  methods: {
    // Used by container components to show the dialogue.
    show (msg, cb) {
      console.log(cb)
      this.msg = msg
      if (cb) {
        this.callback = cb
      } else {
        this.callback = this.defCall
      }
      // broken... $('#alertModal').modal('show')
      this.showAlert = true
    },
    doCallback () {
      // close this first
      this.showAlert = false
      this.callback()
    },
    // Default callback function called when the OK button is clicked.
    // Container components can override this.
    callback () {
      this.defCall()
    },
    defCall () {
      return true
    }
  },
  data () {
    return {
      msg: '',
      showAlert: false
    }
  }
}
</script>
